import * as Types from './Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import ValidatorService from 'src/services/validation/Validation.service';
import InvestorDeck from 'src/entities/InvestorDeck';
import { Validation } from 'src/services/validation/Validator';

export interface CreateInvestorDeckAttempt extends Action {
  type: Types.CREATE_INVESTOR_DECK_ATTEMPT;
}

export interface CreateInvestorDeckSuccess extends Action {
  type: Types.CREATE_INVESTOR_DECK_SUCCESS;
}

export interface CreateInvestorDeckFailure extends Action {
  type: Types.CREATE_INVESTOR_DECK_FAILURE;
  payload: {};
}

export type CreateInvestorDeckAction = CreateInvestorDeckAttempt |
  CreateInvestorDeckSuccess |
  CreateInvestorDeckFailure;

export interface CreateInvestorDeckThunk extends ThunkAction<Promise<CreateInvestorDeckAction>, RootState, null> {
}

export const createInvestorDeckAttempt: ActionCreator<CreateInvestorDeckAttempt> = () => (
  {
    type: Types.CREATE_INVESTOR_DECK_ATTEMPT,
  }
);

export const createInvestorDeckSuccess: ActionCreator<CreateInvestorDeckSuccess> = () => (
  {
    type: Types.CREATE_INVESTOR_DECK_SUCCESS,
  }
);

export const createInvestorDeckFailure: ActionCreator<CreateInvestorDeckFailure> = (error: {}) => (
  {
    type: Types.CREATE_INVESTOR_DECK_FAILURE,
    payload: error
  }
);

export const createInvestorDeck: ActionCreator<CreateInvestorDeckThunk> = (
  investorDeck: InvestorDeck
): CreateInvestorDeckThunk => {

  return (dispatch: Dispatch<RootState>): Promise<CreateInvestorDeckAction> => {
    dispatch(createInvestorDeckAttempt());

    const restrictions: Validation[] = [{value: investorDeck.investorDeckDocument, type: 'fileSize'}];
    const validation = ValidatorService.validate(restrictions);

    return validation.then(() => {
      return ApiClient.investorDeck.create(investorDeck)
        .then((): CreateInvestorDeckSuccess => {

          return dispatch(createInvestorDeckSuccess());
        }).catch((e: { response: { data: { error: {} } } }): CreateInvestorDeckFailure => {
          const errorMessages = ValidatorService
            .translateValidations(e && e.response && e.response.data && e.response.data.error);

          return dispatch(createInvestorDeckFailure(errorMessages));
        });
    }).catch((errors) => {
      return dispatch(createInvestorDeckFailure(errors));
    });

  };
};



// WEBPACK FOOTER //
// ./src/actions/investor-deck/create/CreateInvestorDeck.actions.tsx